import { unstable_usePrompt } from 'react-router-dom'

/**
 *  react-router 6 dropped the support to use Prompt, which basically added a prompt to the users
 *  leaveing the current route under certain conditions. This is a hook that mymics that behavior.
 *  It accepts a "blocker" string (shown in an browser alert) and a "when" condition to show or not
 *  that alert when leaving the route.
 *
 *  Inspiration taken from here: https://gist.github.com/rmorse/426ffcc579922a82749934826fa9f743
 *  Whole tinglado explained here: https://github.com/remix-run/react-router/issues/8139
 *
 *  Update: They removed navigation.block... because semver.
 *  Since everybody got mad, they are now implementing prompts back to the router.
 *  The API is unstable, but so was the gist we used that relied on internals.
 */
export default function usePrompt(message: string, showPrompt: () => boolean = () => true) {
  unstable_usePrompt({ when: showPrompt(), message })
}
